import React, { useState } from 'react';
import { Button } from 'primereact/button';

import { ModalAgregarEmpresa } from './ModalAgregarEmpresa';

export const AgregarEmpresa = (props) => {

    const {funcionRecargaTabla} =props;
    const [mostrarModal, setMostrarModal] = useState(false);

    const mostrar = () => {
        setMostrarModal(true);
    }

    const cerrar = (valor) => {
        setMostrarModal(valor);
        funcionRecargaTabla();
    }

    return (
        <div>
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Patrones</h1>
                        <div className="p-fluid p-grid">
                            <div className="p-col-12 p-md-4">
                                <Button
                                    className="p-button-Primary p-button-raised"
                                    label="Agregar"
                                    icon="pi-md-plus"
                                    tooltip={"Agregar nuevo"}
                                    onClick={mostrar} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalAgregarEmpresa mostrarModal={mostrarModal} funcionCerrarModal={cerrar} />
        </div>
    );
}